import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    Button,
    Table, message,Popconfirm
} from 'antd';
import moment from 'moment'
import 'moment/locale/zh-cn';
import axios from 'axios'
import {baseUrl, reqTrackList,reqCancelled} from '../../api'
import LinkButton from '../../components/link-button'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)
const {Option} = Select;

moment.locale('zh-cn');
const orderStatus = {
    'new': '新建',
    'failed': '已驳回',
    audit: '待审核',
    audited: '待订舱',
    booked: '已订舱',
    boxed: '已装箱',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行',
    cancelled:'已取消'
};

const logisticsStatus = {
    waiting: "待提货",
    transport: '运输中',
    declaring: '报关中',
    released: '已放行',
    boxed: '已装箱',
    destination: '已到达'
}

class TrackList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        loading: false, // 是否正在加载中
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {},
        arrow: 'up-arrow',
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {
        this.columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                sorter: true,
                width: 180,
                render: (text, record) => (
                    <a onClick={() => this.props.history.push('/orderInfo', record)}>{text}</a>
                )
            },
            {
                title: '报关类型',
                dataIndex: 'declarationType',
                render: (text, record) => {
                    let type ='';
                    if (record.packageTypeSmall === 'Y') {
                         type +='零售小包 <br/>';
                    }
                    if (record.packageTypeNormal === 'Y') {
                        type +='本地一般贸易 <br/>';
                    }
                    if (record.packageTypeSale === 'Y') {
                        type +='寄售代销 <br/>';
                    }
                    if (record.packageTypeDeclare === 'Y') {
                        type +='通关一体化 <br/>';
                    } 
                    if (record.packageTypeTransfer === 'Y') {
                        type +='转关运输 <br/>';
                    }
                    if (record.packageTypeNormalOut === 'Y') {
                        type +='外地一般贸易 <br/>';
                    }
                    if (record.packageTypeB2b === 'Y') {
                        type +='B2B直接出口 <br/>';
                    }
                    if (record.packageTypeOverseas === 'Y') {
                        type +='出口海外仓 <br/>';
                    }
                    return  <span dangerouslySetInnerHTML={{ __html: type }}/>
                }
            },
            /*{
                title: '箱数CTNS',
                dataIndex: 'toNum',
            },
            {
                title: '毛重(Kg)',
                dataIndex: 'toGrossWeight',
            },
            /!*{
             title: '净重(Kg)',
             dataIndex: 'toNetWeight',
             },*!/
            {
                title: '总价',
                dataIndex: 'totalValue',
            },*/
            {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            },
            {
                title: '转关地',
                sorter: true,
                dataIndex: 'destinationStartCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationStartCountry}&nbsp;{record.destinationStartCity}
                  </span>
                )
            },{
                title: '目的地',
                sorter: true,
                dataIndex: 'destinationCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '还箱地',
                sorter: true,
                dataIndex: 'boxReturnStation',
            }, {
                title: '集装箱号',
                dataIndex: 'boxNo',
                render: (text, record) => (
                    <span>
                    {record.boxNo.map((c, i) => {
                            return <div key={i}>
                                {c}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            }, {
                title: '班次时间',
                sorter: true,
                dataIndex: 'shiftDt',
            }, {
                title: '预计提货时间',
                sorter: true,
                dataIndex: 'deliveryEstimateDt',
            },{
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
            }, {
                title: '订单状态',
                sorter: true,
                dataIndex: 'orderStatus',
                render: (text, record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            }, {
                title: '物流状态',
                sorter: true,
                dataIndex: 'logisticsStatus',
                render: (text, record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 160,
                render: (text, record) => {
                    if (record.logisticsStatus=='destination' || record.orderStatus=='cancelled') {
                        return <span>
                            <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: record.id})}>物流查询</a>
                        </span>
                    } else if(record.orderStatus=='audit'){
                        return <span>
                        <AuthLinkButton authority="order:edit"
                                        onClick={() => this.props.history.push('/trackEdit', {orderId: record.id})}>编辑</AuthLinkButton>
                            <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: record.id})}>物流查询</a>
                            <Popconfirm title="是否确定取消?" onConfirm={() => this.cancelledOrder(record.id)}>
                             <AuthLinkButton>取消</AuthLinkButton>
                         </Popconfirm> 
                        </span>
                    }else {
                        return <span>
                        <AuthLinkButton authority="order:edit"
                                        onClick={() => this.props.history.push('/trackEdit', {orderId: record.id})}>编辑</AuthLinkButton>
                            <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: record.id})}>物流查询</a>
                            {/*<AuthLinkButton authority="order:search_delivery"
                            onClick={() => this.props.history.push('/trackInfo', {orderId: record.id})}>物流查询</AuthLinkButton>*/}
                            {/* <AuthLinkButton authority="order:download"
                                            onClick={() => window.location.href = baseUrl + "/api/v1/p/file/fileCompressionDownload?orderId=" + record.id + "&orderNo=" + record.orderNo}>下载</AuthLinkButton>*/}
                        </span>
                    }
                }
            }
        ];
    }
    getProducts = async (pageNum, sortData) => {
        const pageSize = 10
        this.pageNum = pageNum // 保存pageNum, 让其它方法可以看到
        const {getFieldsValue} = this.props.form;
        const {deliveryFromDt, deliveryToDt} = this.state
        const values = getFieldsValue();
        values.deliveryFromDt = deliveryFromDt;
        values.deliveryToDt = deliveryToDt;
        values.pageNum = pageNum
        values.pageSize = pageSize
        if (sortData) {
            values.sort = sortData.sort
            values.order = sortData.order
        }
        let result = await reqTrackList(values)
        console.log(result);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }

    }

    componentDidMount() {
        this.getProducts(1)
        var box=document.getElementById("all");
        if(box){ //此处在加一层判断，更加严密，如果box存在的情况下获取
            this.setState({
                allHeight:box.offsetHeight
            })
        }
    }

    componentWillMount() {
        this.initColumns()
    }
    // 取消订单
    cancelledOrder = async (orderId) => {
        let param = new URLSearchParams()
        param.append('orderId', orderId)
        param.append('type', 'cancelled')
        axios({
            method: 'post',
            url: baseUrl + '/api/v1/p/oms/updateReview',
            data: param
          }).then(function (response) {
            if(response.data.code == 200){
                message.info('取消成功');
                window.location.reload();
            }else{
                message.error(response.data.message)
            }
          }).catch(function (error) {
            message.error(error);
          });
    };
    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = this.pageNum
            values.pageSize = 10
            const {deliveryFromDt, deliveryToDt, sortData} = this.state
            values.deliveryFromDt = deliveryFromDt;
            values.deliveryToDt = deliveryToDt;
            if (sortData) {
                values.sort = sortData.sort
                values.order = sortData.order
            }
            if (!err) {
                this.reqTrackList(values);
            }
        });
    };

    reqTrackList = async (po) => {
        const result = await reqTrackList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
            this.initColumns()
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        }
    };


    // 日期选择
    onDateChange = (value, dateString) => {
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        this.setState({
            deliveryToDt: dateString
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        }
        this.setState({
            sortData
        })
        this.getProducts(pageNum, sortData)
    };
    moreClick = () => {
        const {arrow} = this.state;
        this.setState({
            arrow: arrow === 'down-arrow' ? 'up-arrow' : 'down-arrow'
        })
    };
    render() {

        // 取出状态数据
        const {orderList, total} = this.state


        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                lg: {span: 7},
                md: {span: 9},
            },
            wrapperCol: {
                lg: {span: 14},
                md: {span: 12},
            },
        }
        const config = {
            rules: [{required: false, message: 'Please select time!'}],
        };

        return (
            <div id='all'>
                <div className='box-shadow margin-bootom'>
                    <div className='head-title'>委托单信息列表
                    <span className="arrow" onClick={this.moreClick}>{this.state.arrow === 'down-arrow' ? '收起':'更多'}<span className={this.state.arrow}></span></span></div>
                    <br/>
                    <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={6}>
                                <Form.Item label="订单编号">
                                    {getFieldDecorator('orderNo', {})(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="集装箱号">
                                    {getFieldDecorator('boxNo', {})(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="提货时间" className='time-input-to'>
                                    {getFieldDecorator('deliveryFromDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange} style={{width: "100%", minWidth: 10}}
                                    />)}

                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={"至"} className='time-input-to'>
                                    {getFieldDecorator('deliveryToDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange2} style={{width: "100%", minWidth: 10}}
                                    />)}
                                </Form.Item>
                            </Col>
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="起运地">
                                    {getFieldDecorator('departure', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="转关地">
                                    {getFieldDecorator('transitPoint', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="目的地">
                                    {getFieldDecorator('destination', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="还箱地">
                                    {getFieldDecorator('boxReturnStation', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="订单状态">
                                    {getFieldDecorator('orderStatus', {
                                        initialValue: '',
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        <Option value="new">新建</Option>
                                        <Option value="audit">待审核</Option>
                                        <Option value="failed">已驳回</Option>
                                        <Option value="audited">待订舱</Option>
                                        <Option value="booked">已订舱</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="declare">待报关</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                        <Option value="cancelled">已取消</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="物流状态">
                                    {getFieldDecorator('logisticsStatus', {
                                        initialValue: '',
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        <Option value="waiting">待提货</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="transport">运输中</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                        <Option value="destination">已到达</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col> : null}
                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType='submit'
                                        style={{float: 'right', marginRight: '13%'}}>查询</Button>
                                <AuthButton type='primary' style={{float: 'right', marginRight: '20px'}}
                                            authority={"order_start:commit"} onClick={e => {
                                    this.props.history.push('/orderTicket')
                                }}>新增</AuthButton>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Table
                        rowKey='id'
                        columns={this.columns}
                        dataSource={orderList}
                        scroll={{x: 1800,y: this.state.allHeight/1.7}}
                        bordered
                        onChange={this.handleTableChange}
                        pagination={{
                            current: this.pageNum,
                            total: total,
                            showQuickJumper: true,
                        }}
                        size="middle"
                    />
                </div>
            </div>

        )
    }
}
const TrackListFrom = authorizePage("order:search_delivery")(Form.create()(TrackList))
export default TrackListFrom